import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";

import css from "./activity_type_badge.module.scss";

export type ActivityType = { key: string; name?: string };

export type ActivityTypeBadgeProps = {
  type: ActivityType;
};

const ICON_NAMES = {
  role: "role",
  event: "calendar",
  question: "question",
  suggestion: "chat",
  position: "work",
  lesson: "book",
  engagement: "engagement",
  project: "path"
};

export const ActivityTypeBadge = ({ type }: ActivityTypeBadgeProps) => {
  const iconName = ICON_NAMES[type.key];

  return (
    <Inline gap="spacingMd" className={css.root}>
      {iconName && <Icon name={iconName} size="sm" />}
      <Typography variant="labelRegular">{type.name}</Typography>
    </Inline>
  );
};
